import { BLOCK_TYPES, IPage, IPageBlock } from '../../../page';
import { IFeaturedAd } from '../../featured-ad';

export function useFeaturedAds (page: IPage | null): IFeaturedAd[] {
    if (page === null) {
        return [];
    }

    return page.blocks.filter((block: IPageBlock): boolean => {
        return block.type === BLOCK_TYPES.FEATURED_AD;
    }).map((block: IPageBlock): IFeaturedAd => {
        return block.content as IFeaturedAd;
    });
}
